import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyD3fHMR8eKZxU8wnxjKkV0RqSEeI-vB8ME",
  authDomain: "tekstovipjesme-23bff.firebaseapp.com",
  projectId: "tekstovipjesme-23bff",
  storageBucket: "tekstovipjesme-23bff.appspot.com",
  messagingSenderId: "1096783949088",
  appId: "1:1096783949088:web:0adb919845c2fd2e1a3b45",
  measurementId: "G-M50ZPZEZ1Z"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
